import React, {  useState } from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import logo from "../assest/login.png";
//import FormularioLogin from "../component/Formulario_Login";
import FormularioLogin from "../components/Formulario_Registro";
import AuthService from "../service/auth-service";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import cflService from "../service/cfl-service";

const Registro = () => {

    let navigate = useNavigate();
    
    const [loading, setLoading] = useState(false);

    const onChangeValores = (e) => {
        console.log(e)
        setLoading(true);
        AuthService.register(e.UserName, e.Email, e.Password)
            .then((response) => {
                cflService.enviarConfirmacion(e.Email, e.UserName)
                    .then(() => {
                      navigate("/afterregister")
                       window.location.reload();
                        setLoading(false);
                    })

            })
            .catch((error) => {
                setLoading(false);
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                //console.log(resMessage);
                Swal.fire({
                    text: resMessage,
                    icon: "error",

                })
            })
    }



    return (
        <Container className="App mb-3">
        <Row>
            <Col md={12} className=" d-flex justify-content-center align-items-center">
            <div className="text-center  titulo">
                <div className="container-login">
                    <Card >
                        <div className="mt-3">
                            <img src={logo} alt="perfil" width="80" />
                        </div>

                        <Card.Body>
                            <Card.Title><h2>Registrate en Administración CFL401 SADA</h2></Card.Title>
                            <FormularioLogin valores={onChangeValores} loading={loading} />
                        </Card.Body>
                    </Card>
                </div>
            </div>
            </Col>
        </Row>
            
        </Container>
    )
}
export default Registro;